// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".slide[data-v-3d755fe0]{height:auto;max-width:500px;padding-right:2rem;width:calc(100vw - 2rem)}@media screen and (min-width:768px){.slide[data-v-3d755fe0]{max-width:336px}}@media screen and (min-width:1024px){.slide[data-v-3d755fe0]{max-width:432px}}@media screen and (min-width:1440px){.slide[data-v-3d755fe0]{max-width:640px}}.slide img[data-v-3d755fe0]{display:block;height:auto;margin:0 auto;width:100%}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
